import {
  Button,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import { useStepperData } from "../../../Helpers/Contexts/stepperContext";
import { useStyles } from "../styles";
import { REGEX } from "../../../Helpers/constant";
import { Box } from "@mui/system";
import FileUpload from "../../../Components/FileUpload";
import { useRef, useState } from "react";
import { pdfIcon } from "../../../Assets";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { handleFiles } from "../../../Utils/helperFunctions";
import { useToast } from "../../../Helpers/Contexts/toastContext";

const CoachCertificate = () => {
  const classes = useStyles();
  const { showToast } = useToast();
  const { formData, updateFormData } = useStepperData();
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [loading, setLoading] = useState(false);

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    updateFormData("Certified_Coach__c", value);
  };

  const handleFileSelect = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    event.preventDefault();

    setLoading(true);
    const data = await handleFiles(event, [
      "image/jpeg",
      "image/png",
      "image/jpg",
      "application/pdf",
    ]);
    if (data?.success) {
      updateFormData("Coach_Certification_URL__c", data?.message);
      setLoading(false);
    } else {
      showToast("error", data?.message);
      setLoading(false);
    }
  };

  return (
    <>
      <Typography
        variant="h1"
        className={`${classes.headerTitle} label required`}
        mb={2}
      >
        Are you a certified coach?
      </Typography>

      <RadioGroup
        row
        value={formData.Certified_Coach__c || ""}
        onChange={handleRadioChange}
      >
        <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
        <FormControlLabel value="No" control={<Radio />} label="No" />
      </RadioGroup>

      {formData.Certified_Coach__c === "Yes" && (
        <Box
          sx={{
            mb: 2,
            mt: 3,
          }}
        >
          {formData?.Coach_Certification_URL__c ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 2,
                background: "#161616",
                padding: "12px 16px",
                borderRadius: "8px",
                marginBottom: 1,
              }}
            >
              <Box sx={{ display: "flex", gap: "12px", alignItems: "center" }}>
                <img
                  src={pdfIcon}
                  alt="Document Icon"
                  style={{ width: "24px", height: "24px" }}
                />
                <Box>
                  <Typography variant="body1" color="white">
                    certificate
                  </Typography>
                  <Typography variant="body1" color={"success.main"}>
                    Uploaded
                  </Typography>
                </Box>
              </Box>
              <Button
                onClick={() => updateFormData("Coach_Certification_URL__c", "")}
              >
                <DeleteOutlineIcon
                  style={{ color: "white", fontSize: "24px" }}
                />
              </Button>
            </Box>
          ) : (
            <FileUpload
              onImageSelect={handleFileSelect}
              acceptedFileTypes="image/*,application/pdf"
              fileInputRef={fileInputRef}
            />
          )}
        </Box>
      )}
    </>
  );
};

export default CoachCertificate;
